import React, { useContext } from 'react';
import { Container, Grid } from 'semantic-ui-react';
import Link from './Link';
import questionMark from '../assets/images/question-mark.svg';
import { TitleContext } from '../context';
import { LargeMonitorContext } from '../context';

const Wayfinder = (props) => {
  const { parent_title, links } = props;

  const pageTitleContext = useContext(TitleContext);
  const largeMonitorContext = useContext(LargeMonitorContext);

  if (!links) {
    return null;
  }

  const filteredLinks = links.filter(
    (link) => link.title && link.title !== pageTitleContext
  );

  if (filteredLinks.length === 0) {
    return null;
  }

  return (
    <section className="wayfinder">
      <Container>
        <Grid stackable columns={2} verticalAlign="middle">
          <Grid.Row>
            {largeMonitorContext && <Grid.Column width={1}></Grid.Column>}
            <Grid.Column width={largeMonitorContext ? 5 : 6}>
              <div className="wayfinder__intro-column">
                <img
                  className="wayfinder__image"
                  src={questionMark}
                  alt="question mark icon"
                />
                <div className="wayfinder__heading-wrapper">
                  {pageTitleContext && (
                    <h3
                      className="wayfinder__heading"
                      dangerouslySetInnerHTML={{
                        __html: `Looking for something else in <br> ${
                          parent_title ? parent_title : pageTitleContext
                        }`,
                      }}
                    />
                  )}
                  <p className="wayfinder__sub-heading">Explore another page</p>
                </div>
              </div>
            </Grid.Column>
            <Grid.Column width={largeMonitorContext ? 5 : 6}>
              {filteredLinks && (
                <ul className="wayfinder__link-list">
                  {filteredLinks.map(
                    (link, i) =>
                      link.title !== pageTitleContext && (
                        <li key={i} className="wayfinder__link-item">
                          <Link to={link.uri}>{link.title}</Link>
                        </li>
                      )
                  )}
                </ul>
              )}
            </Grid.Column>
            {largeMonitorContext && <Grid.Column width={1}></Grid.Column>}
          </Grid.Row>
        </Grid>
      </Container>
    </section>
  );
};

export default Wayfinder;
